import { defineStore } from "pinia";
import { useLocalStorage } from "@vueuse/core";
import { useListBookingsStore} from "./ListBookingsStore.js";


export const useUserStore = defineStore("user", {
    state: () => ({
        user: useLocalStorage('user', {
            data: {
                preferences: null,
                agent_display_name: null,
                user_name: null
            }
        }),
        redirect: localStorage.getItem('redirect') || null,
        error: {
            message: ''
        }
    }),

    actions: {
        setRedirect(path) {
            this.redirect = path;
            localStorage.setItem('redirect', path);
        },
        clearRedirect() {
            this.redirect = null;
            localStorage.removeItem('redirect');
        },
        async fetchUser(router) {

            try {
                const res = await axios.get("/api/user");
                this.user = res.data || {
                    data: {
                        preferences: null,
                        agent_display_name: null,
                        user_name: null,
                        main_user: false
                    }
                };
            } catch (error) {
                this.user = {
                    data: {
                        preferences: null,
                        agent_display_name: null,
                        user_name: null,
                        main_user: false
                    }
                };
                console.error("Failed to fetch user data:", error);

                // Set the redirect path to the current fullPath
                this.setRedirect(router.currentRoute.value.fullPath);

                router.push({name: 'user-login'});
            }
        },

        async login(router, agentLogin, password, remember) {

            try {
                // Load redirect from local storage to ensure it is set correctly
                this.redirect = localStorage.getItem('redirect');
                await axios.get('/sanctum/csrf-cookie');
                console.log('login redirect before:', this.redirect);

                const loginFieldsArray = {
                    'login': agentLogin,
                    'password': password,
                    'remember': remember
                };

                this.error.message = '';

                const res = await axios.post('/api/login', loginFieldsArray);
                this.user = res.data;
                this.error.message = '';

                console.log('login redirect after:', this.redirect);

                // If redirect === /logout that was an intentional logout so the new login will go to list-bookings
                if (this.redirect) {
                    router.push(this.redirect);
                } else {
                    router.push({ name: 'list-bookings' });
                }

                // Clear the redirect after successful login
                this.clearRedirect();
            } catch (error) {
                this.error.message = 'Incorrect login details.';
                console.error("Login failed:", error);
            }
        },

        async logout(famil = false) {

            // Reset bookingsList on logout
            const listBookingsStore = useListBookingsStore();
            listBookingsStore.resetData();

            axios.get('/sanctum/csrf-cookie').then(() => {
                axios
                    .post('/api/logout')
                    .then(() => {
                        this.redirect = null;
                        this.user.data = {
                            preferences: null,
                            agent_display_name: null,
                            user_name: null
                        };
                        if(famil){
                            window.location.reload()
                        }
                        else{
                            this.router.push({
                                name: 'user-login'
                            })
                        }
                    })
                    .catch(() => {

                    })
            })

        },

        resetUser() {
            this.user.data = {
                preferences: null,
                agent_display_name: null,
                user_name: null
            };
            localStorage.removeItem('user')
        }
    }
})


